import { ChatFilterSlaStatus, ChatListAtom, ChatStatuses } from '../typings';
import { deserializeTagIdsFromQueryParams, deserializeTagsFromQueryParams } from './deserialize-tags';
import { decodeConditionsFromUrl } from '../components/chat-list-section/custom-field-filter/utils';

export const getDefaultChatFilters = (): ChatListAtom => {
  // eslint-disable-next-line no-restricted-globals
  const queryParams = new URLSearchParams(location?.search);
  const userId = queryParams.get('assignedUserId') ?? '';
  const slaStatus = (queryParams.get('slaStatus') as ChatFilterSlaStatus) ?? 'non-breached';
  const status = (queryParams.get('status') as ChatStatuses) ?? ChatStatuses.UNRESOLVED;
  const conversationView = queryParams.get('chatType') === 'WA_GROUP' ? 'groups' : 'chats';
  const tags = deserializeTagsFromQueryParams(queryParams);
  const tagIds = deserializeTagIdsFromQueryParams(queryParams);
  const waba = queryParams.has('waba') ? (queryParams.get('waba') as string).split(',').filter(Boolean) : [];
  const customFieldConditions = decodeConditionsFromUrl(queryParams.get('cfc') ?? '');
  return {
    searchTerm: '',
    isSearchActive: false,
    conversationView,
    assignedUserId: userId,
    tags,
    status,
    customList: {} as { [key: string]: string },
    leadCustomFieldIdList: undefined,
    currentCustomListId: '',
    waba,
    slaStatus,
    tagIds,
    customFieldConditions,
  };
};
